import {z} from 'zod';

import {multiString, singleString} from './queryParamTransforms';
import {SERVICE_ORDER_STATES} from './serviceOrderStates';

/**
 * Single source of truth for mechanic-labour report filters.
 * Used both to parse incoming query params and as the `filters` echo in responses.
 */
export const mechanicFiltersSchema = z.object({
  openedFrom: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  openedTo: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  closedFrom: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  closedTo: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  mechanic: multiString,
  state: multiString.pipe(z.array(z.enum(SERVICE_ORDER_STATES)).optional()),
  variant: multiString,
});

export type MechanicFilters = z.infer<typeof mechanicFiltersSchema>;
